const endpoint = "https://public-api.wordpress.com/wp/v2/sites/porkies.home.blog"

export default {
  posts: endpoint + "/posts",
  pages: endpoint + "/pages"
};
